import { Pipe, PipeTransform } from '@angular/core';
import { OrderingService } from '@shared/services';

@Pipe({
  name: 'sort',
})
export class SortPipe implements PipeTransform {
  constructor(private orderingService: OrderingService) {}

  transform(
    list: any[],
    propertyName: string,
    direction?: 'asc' | 'desc',
    caseSensitive?: boolean
  ): any[] {
    return this.orderingService.order(
      list,
      propertyName,
      direction,
      caseSensitive
    );
  }
}
